import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate, useParams, Link} from "react-router-dom";
import {DepartmentService} from "../services/DepartmentService";
import {setCreateButton, setSearchHandler, setTitle} from "../actions/main";
import {ArtistService} from "../services/ArtistService";
import {useFormik} from "formik";
import FormGroup from "../components/FormGroup";
import {InputText} from "primereact/inputtext";
import {InputTextarea} from "primereact/inputtextarea";
import {Button} from "primereact/button";
import {EventsService} from "../services/EventsService";
import {CashService} from "../services/CashService";
import {Calendar} from "primereact/calendar"
import formater from "../helpers/formater";
import {Dropdown} from "primereact/dropdown";
import {Checkbox} from "primereact/checkbox";
import Loader from "../components/Loader";
import {InputNumber} from "primereact/inputnumber";

function Artist() {

    const dispatch = useDispatch()
    const locationParams = useParams()
    const [isNew, setIsNew] = useState(true)
    const [event, setEvent] = useState(false)
    const [loaded, setIsLoaded] = useState(false)
    const [artists, setArtists] = useState(false)
    const [cashOperations, setCashOperations] = useState([])
    const navigation = useNavigate()

    const currentDepartment = useSelector(function (state) {
        return state.currentDepartment
    });

    // Функция для получения ссылки на кассу
    const getCashLink = () => {
        if (isNew || !locationParams.eventId) {
            // Для новых событий - ссылка на кассу
            return '/cash'
        }
        
        if (cashOperations.length > 0) {
            // Если есть операции - ссылка на просмотр с фильтром по событию
            return `/cash?event_id=${locationParams.eventId}`
        } else {
            // Если нет операций - ссылка на кассу с параметром для создания новой операции
            return `/cash?event_id=${locationParams.eventId}&create=true`
        }
    };

    // Функция для получения текста ссылки
    const getCashLinkText = () => {
        if (isNew || !locationParams.eventId) {
            return 'Создать операцию'
        }
        
        if (cashOperations.length > 0) {
            const totalAmount = cashOperations.reduce((sum, op) => sum + (op.amount || 0), 0)
            return `Просмотр операций (${formater.amountFormat(totalAmount)})`
        } else {
            return 'Создать операцию'
        }
    };

    const updateData = () => {
        EventsService.GetById(locationParams.eventId, '').then((res) => {

            setEvent(res)
            let d = res
            if(res.date){
                d.date = new Date(res.date)
            }
            dispatch(setTitle(res.name))
            artistForm.setValues(res, false)
            setIsLoaded(true)
        })
        
        // Загружаем кассовые операции для этого события
        if (locationParams.eventId && !isNew) {
            CashService.GetList({event_id: locationParams.eventId, limit: 1000}).then((res) => {
                setCashOperations(res.items || [])
            }).catch((error) => {
                console.log('Ошибка загрузки кассовых операций:', error)
                setCashOperations([])
            })
        }
    }

    useEffect(() => {
        dispatch(setTitle(''))
        dispatch(setCreateButton(false))
        dispatch(setSearchHandler(false))

        ArtistService.GetList({filter: {client_id: currentDepartment}}).then((res) => {

            setArtists(res.items)
        })

        if (locationParams.eventId === 'create') {
            setIsNew(true)
            dispatch(setTitle('Новое мероприятие'))
            setIsLoaded(true)

        } else {
            setIsNew(false)
            updateData()

        }
    }, [currentDepartment]);

    const artistForm = useFormik({
        initialValues: {
            name: ''
        },
        validate: (data) => {
            let errors = {}

            if (!data.name) {
                errors.name = 'Укажите название'
            }

            if (!data.date) {
                errors.date = 'Укажите дату'
            }

            return errors
        },
        onSubmit: (data) => {
            setIsLoaded(false)
            data.client_id = currentDepartment;
            data.date = formater.dateWithOffset(data.date)


            if(event && event.id){
                EventsService.Update(event.id, data).then((res) => {
                    setIsLoaded(true)
                    navigation('/events')
                })
            } else {
                EventsService.Create(data).then((res) => {
                    setIsLoaded(true)
                    navigation('/events')
                })
            }
        }
    })

    console.log(artists)

    return (
        <>
            <div className="card edit-department">
                <div className="card-body">
                    <form onSubmit={artistForm.handleSubmit}>

                        <h3>Общая информация</h3>

                        {isNew || event ?
                        <div className="row">
                            <div className="col-md-4">
                                <FormGroup label={'Название'} error={artistForm.errors.name}>
                                    <InputText value={artistForm.values.name} onChange={(e) => artistForm.setFieldValue('name', e.target.value)}/>
                                </FormGroup>
                            </div>
                            <div className="col-md-3">
                                <FormGroup label={'Дата'} error={artistForm.errors.date}>
                                    <Calendar icon={'pi pi-calendar'} showIcon={true} dateFormat={'dd.mm.yy'} value={artistForm.values.date} onChange={(e) => artistForm.setFieldValue('date', e.target.value)}/>
                                </FormGroup>
                            </div>

                            <div className="row">
                                <div className="col-md-5">
                                    <FormGroup label={'Артист'} error={artistForm.errors.artist_id}>
                                        {artists &&
                                            <Dropdown filter={true} options={artists.map((el) => {

                                                return {
                                                    value: el.id, label: el.name
                                                }

                                            })} value={artistForm.values.artist_id} onChange={(e) => artistForm.setFieldValue('artist_id', e.target.value)}/>
                                        }
                                    </FormGroup>
                                </div>
                                <div className="col-md-3">
                                    <FormGroup label={'Продано билетов'}>
                                        <InputNumber value={artistForm.values.ticket_sale} onChange={(e) => artistForm.setFieldValue('ticket_sale', e.value)}/>
                                    </FormGroup>
                                </div>
                            </div>


                            <h3>Расходы</h3>

                            <div className="row">

                                <div className="col-12">
                                    <div className="row align-items-center">
                                        <div className="col-4">
                                            <FormGroup>
                                                <div className={'d-flex align-items-center gap-3'}>
                                                    <Checkbox checked={!!artistForm.values.is_canceled} onChange={(e) => artistForm.setFieldValue('is_canceled', !!e.checked)} inputId={'is_canceled'}/>
                                                    <label htmlFor="is_canceled" className={'m-b-0'}>Мероприятия отменилось</label>
                                                </div>

                                            </FormGroup>
                                        </div>
                                        <div className="col-4">
                                            <FormGroup label={'Убыток при отмене'}>
                                                <InputNumber value={artistForm.values.canceled_amount} onChange={(e) => artistForm.setFieldValue('canceled_amount', e.value)} currency={'RUB'} mode={'currency'}/>
                                            </FormGroup>
                                        </div>
                                    </div>

                                </div>

                                <div className="col-md-4">
                                    <FormGroup label={'Гонорар артиста'} error={artistForm.errors.artist_fee}>
                                        <InputNumber value={artistForm.values.artist_fee} onChange={(e) => artistForm.setFieldValue('artist_fee', e.value)}/>
                                    </FormGroup>
                                </div>
                                <div className="col-md-4">
                                    <FormGroup label={'Тип гонорара'} error={artistForm.errors.artist_fee_type}>
                                        <Dropdown options={[
                                            {label: '%', value: 2},
                                            {label: 'фикс.', value: 1}
                                        ]} value={artistForm.values.artist_fee_type} onChange={(e) => artistForm.setFieldValue('artist_fee_type', e.target.value)}/>
                                    </FormGroup>
                                </div>

                                <div className="col-md-4">
                                    <FormGroup label={'Корректировка гонорара артиста'} error={artistForm.errors.artist_fee_correct}>
                                        <InputNumber value={artistForm.values.artist_fee_correct} onChange={(e) => artistForm.setFieldValue('artist_fee_correct', e.value)}/>
                                    </FormGroup>
                                </div>
                                <div className="col-md-4">
                                    <FormGroup label={'РАО (фикс)'} error={artistForm.errors.rao}>
                                        <InputNumber value={artistForm.values.rao} onChange={(e) => artistForm.setFieldValue('rao', e.value)}/>
                                    </FormGroup>
                                </div>
                                <div className="col-md-4">
                                    <FormGroup label={'Бытовой райдер'} error={artistForm.errors.raider_b}>
                                        <InputNumber value={artistForm.values.raider_b} onChange={(e) => artistForm.setFieldValue('raider_b', e.value)}/>
                                    </FormGroup>
                                </div>
                                <div className="col-md-4">
                                    <FormGroup label={'Технический райдер'} error={artistForm.errors.raider_t}>
                                        <InputNumber value={artistForm.values.raider_t} onChange={(e) => artistForm.setFieldValue('raider_t', e.value)}/>
                                    </FormGroup>
                                </div>
                                <div className="col-md-4">
                                    <FormGroup label={'Свет/звук'} error={artistForm.errors.sound}>
                                        <InputNumber value={artistForm.values.sound} onChange={(e) => artistForm.setFieldValue('sound', e.value)}/>
                                    </FormGroup>
                                </div>
                            </div>

                            <h3>Доходы</h3>
                            <div className="row">
                                <div className="col-md-6">
                                    <FormGroup label={'Ресторан'}>
                                        <InputNumber value={artistForm.values.restaurant} onChange={(e) => artistForm.setFieldValue('restaurant', e.value)}/>
                                    </FormGroup>
                                </div>
                                <div className="col-md-6">
                                    <FormGroup label={'R-Keeper (зал мероприятия)'}>
                                        {artistForm.values.restaurant_synced_at ? (
                                            <div style={{paddingTop: 8}}>
                                                Кухня: <strong>{formater.amountFormat(artistForm.values.restaurant_kitchen || 0)}</strong>
                                                {' · '}Бар: <strong>{formater.amountFormat(artistForm.values.restaurant_bar || 0)}</strong>
                                                <div style={{fontSize: 12, color: '#888'}}>
                                                    Всего по R-Keeper: {formater.amountFormat(artistForm.values.restaurant_rk || 0)}
                                                    {', синхр. '}{new Date(artistForm.values.restaurant_synced_at).toLocaleString()}
                                                    {Number(artistForm.values.restaurant) !== Number(artistForm.values.restaurant_rk) ? ' — «Ресторан» изменён вручную' : ''}
                                                </div>
                                            </div>
                                        ) : (
                                            <div style={{paddingTop: 8, color: '#888'}}>нет данных из R-Keeper</div>
                                        )}
                                    </FormGroup>
                                </div>
                            </div>
                            
                            <div className="row">
                                <div className="col-md-6">
                                    <FormGroup label={'План продаж'}>
                                        <InputNumber value={artistForm.values.sales_plan} onChange={(e) => artistForm.setFieldValue('sales_plan', e.value)}/>
                                    </FormGroup>
                                </div>
                                <div className="col-md-6">
                                    <FormGroup label={'Факт продаж'}>
                                        <Link 
                                            to={getCashLink()} 
                                            className="btn btn-outline-primary d-flex align-items-center justify-content-center"
                                            style={{minHeight: '38px', textDecoration: 'none'}}
                                        >
                                            <i className="pi pi-money-bill me-2"></i>
                                            {getCashLinkText()}
                                        </Link>
                                    </FormGroup>
                                </div>
                            </div>
                            
                            <div className="row">
                                <div className="col-md-6">
                                    <FormGroup label={'План реклама'}>
                                        <InputNumber value={artistForm.values.adv_plan} onChange={(e) => artistForm.setFieldValue('adv_plan', e.value)}/>
                                    </FormGroup>
                                </div>
                                <div className="col-md-6">
                                    <FormGroup label={'Факт реклама'}>
                                        <InputNumber value={artistForm.values.adv_fact} onChange={(e) => artistForm.setFieldValue('adv_fact', e.value)}/>
                                    </FormGroup>
                                </div>
                            </div>
                        </div>
                        : <Loader/>}







                        <Button label={'Сохранить'} type={'submit'} loading={!loaded}/>

                    </form>
                </div>
            </div>
        </>
    )

}

export default Artist